/* eslint-disable no-shadow */
import axios from 'axios';

const state = {
  purchases: {},
  total: 0,
  stripe: {
      paymentRequired: false,
      base: null,
      elements: [],
      cardEmpty: true,
      dateEmpty: true,
      cvcEmpty: true
  },
  cardLoaded: false
};

const mutations = {
  storePurchase(state, value) {
      state.purchases[value.id] = {
          'price' : value.price,
          'quantity': value.quantity,
      };
  },
  removePurchase(state, id) {
      delete state.purchases[id];
  },
  setStripe(state, stripe) {
    state.stripe.base = stripe;
  },
  setStripeElements(state, elements) {
    state.stripe.elements = elements;
  },
  setPaymentRequired(state) {
    state.stripe.paymentRequired = true;
  },
  setCardLoaded(state) {
    state.cardLoaded = true;
  },
  setTotal(state, total) {
    state.total = total;
  },
};

const getters = {};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
